import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoadingService } from '../../../_services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.css'
})
export class LoadingComponent {
  constructor(public loadingService: LoadingService) { }
}
